import * as React from 'react';


export function useAsyncDependency(
  callback: () => Promise<unknown>,
  deps: unknown[],
): boolean {
  const [loading, setLoading] = React.useState(true);

  React.useEffect(() => {
    setLoading(true);

    callback()
      .catch((ex) => {
        throw ex;
      })
      .finally(() => {
        setLoading(false);
      });
  }, deps);

  return loading;
}
